import { render, staticRenderFns } from "./ticket-home.vue?vue&type=template&id=467ecec8&scoped=true&"
import script from "./ticket-home.vue?vue&type=script&lang=js&"
export * from "./ticket-home.vue?vue&type=script&lang=js&"
import style0 from "./ticket-home.vue?vue&type=style&index=0&id=467ecec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467ecec8",
  null
  
)

export default component.exports